"use strict";function getMiniCourseDraftList$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getMiniCourseDraftList$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.edu.getMiniCourseDraftList";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.0.15"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.15"},_a)),exports.getMiniCourseDraftList$=getMiniCourseDraftList$,exports.default=getMiniCourseDraftList$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/edu/getMiniCourseDraftList.js
// module id = 947
// module chunks = 106